angular.module('EdxClassroomReportModule')
  .directive('edxClassroomStatsPane', function() {
    return {
      restrict: 'E',
      scope: {
        edxClassroomData: '=',
        edxViewMode: '='
      },
      templateUrl: '/resources/components/report/classroom/classroom-stats-pane/edx-classroom-stats-pane.directive.html',
      controller: [
          '$scope',
          'dblUsageStatus',
          function(
            $scope,
            dblUsageStatus) {

            $scope.getStatusStyle = function(status) {
              return "text-" + dblUsageStatus.getStatusString(status);
            };
      }]
    };
  });